import { AffidavitI } from '../domain';
import AffidavitRepositoryI from '../repository/AffidavitRepositoryI';
import AffidavitServiceI from './AffidavitServiceI';

export default class AffidavitService implements AffidavitServiceI {
  constructor(private affidavitRepository: AffidavitRepositoryI) {}

  public async create(
    customerId: string,
    employeeId: string,
    affidavitType?: string,
  ): Promise<AffidavitI> {
    return this.affidavitRepository.create(
      customerId,
      employeeId,
      affidavitType,
    );
  }

  public async update({
    customerId,
    metadata,
    affidavitType,
  }: {
    customerId: string;
    metadata: {
      affidavitId: string;
      selectedSign: {
        text: string;
        font: string;
      };
      finalBeneficiaryStatementReviewedAndCorrect?: boolean;
      statementReviewedAndCorrect?: boolean;
    };
    affidavitType?: string;
  }): Promise<AffidavitI> {
    return this.affidavitRepository.update(customerId, metadata, affidavitType);
  }

  public async get(
    customerId: string,
    onlyLast: boolean,
    affidavitType?: string,
  ): Promise<AffidavitI[]> {
    return this.affidavitRepository.get(customerId, onlyLast, affidavitType);
  }
}
